import {Component, Input, OnInit} from "@angular/core";
import {TestService} from "@ispm/test/services/test.service";
import _ from "lodash";
import {IoptionElemet} from "@ispm/shared/interfaces/IoptionElemet";
import {Observable, Subject} from "rxjs";

@Component({
  selector: 'gen-release-interpretation',
  templateUrl: './release-interpretation.component.html'
})

export class ReleaseInterpretationComponent implements OnInit{
  public providers;
  public payload: { formName: string, options: IoptionElemet[] };
  public tunnel$: Subject<any>;
  public callback: (modal) => Observable<Response>;
  public modalPayload: any;
  public modal;

  constructor(
    private testService: TestService
  ) {}

  ngOnInit(): void {
    this.tunnel$
      .asObservable()
      .filter(value => value.emitter !== 'child')
      .subscribe(next => {
        this.callback(this.modal);
        this.tunnel$.next({ emitter: 'children', value: 1});
        next.value;
      });
    this.modalPayload = this.payload['modalPayload'];

    this.providers = _.get(this.testService.testConfiguration, 'therapyMatch.providers', null);
    // in case we don't have any aberrations selected, and we have a flag to proceed without selection in the test config.
    if (this.canProceedWithoutAberrationSelection() && !this.modalPayload.isAnyAberrationSelected) {
      this.providers = null;
    }
    if (this.providers) {
      this.providers = [...this.providers];
    }
  }

  public canProceedWithoutAberrationSelection(): any {
    return this.testService.testConfiguration.reviewTestResults && this.testService.testConfiguration.reviewTestResults.canProceedWithoutAberrationSelection;
  }
}
